import { useElitePlansLanding } from '../ElitePlansLandingContext'
import { ElitePlansAllocationPreview } from './ElitePlansAllocationPreview'
import { ElitePlansAdviceCarousel } from './ElitePlansAdviceCarousel'
import { ElitePlansAdviceCarouselSkeleton } from './ElitePlansAdviceCarouselSkeleton'
import { ElitePlansAllocationPreviewSkeleton } from './ElitePlansAllocationPreviewSkeleton'
import { ElitePlansFeaturesSection } from './ElitePlansFeaturesSection'
import { ElitePlansCompareAccordion } from './ElitePlansCompareAccordion/ElitePlansCompareAccordion'
import { ElitePlansSectionSeparator } from './ElitePlansSectionSeparator'
import CardsTrustMarker from '../../../components/elite/CardsTrustMarker'
import VideoTrustMarker from '../../../components/elite/VideoTrustMarker'
import { ElitePlansTrustStatement } from './ElitePlansTrustStatement'

/** Below-hero sections for member / prime dashboards (status-driven skeletons). */
export function ElitePlansDashboardBelowFold({
  isContentLoading,
  showTestimonials = false,
  eliteBundleLabel
}: {
  isContentLoading: boolean
  showTestimonials?: boolean
  eliteBundleLabel?: string
}) {
  const { activeTab } = useElitePlansLanding()
  const hasAllocationPreview = Boolean(activeTab.allocationPreview)

  return (
    <div className='bg-[color:var(--ep-below-hero)]'>
      {/* Figma: Compare sits first in below-fold, above allocation / advice / features */}
      <ElitePlansCompareAccordion />
      <ElitePlansSectionSeparator withMargin={false} />

      {isContentLoading ? (
        <>
          {hasAllocationPreview ? <ElitePlansAllocationPreviewSkeleton /> : null}
          {hasAllocationPreview ? <ElitePlansSectionSeparator /> : null}
          <ElitePlansAdviceCarouselSkeleton />
        </>
      ) : (
        <>
          {hasAllocationPreview ? <ElitePlansAllocationPreview /> : null}
          {/* Dashboard never mounts SEBI rebalancing — don't gate a leading separator on funds count */}
          <ElitePlansAdviceCarousel rebalancingSectionAbove={false} />
        </>
      )}

      <ElitePlansFeaturesSection eliteBundleLabel={eliteBundleLabel} />
      {/* CardsTrustMarker bleeds with -mx-5, so it needs a px-5 parent */}
      {showTestimonials ? (
        <div className='my-12 flex flex-col gap-6 px-5'>
          <VideoTrustMarker />
          <CardsTrustMarker />
        </div>
      ) : null}
      <ElitePlansTrustStatement />
    </div>
  )
}
